import apiClient from './config';
import { Classroom, EntityUsage, ReassignResponse, DeleteResponse } from '../../types/index';

export const fetchClassrooms = async (): Promise<Classroom[]> => {
    const response = await apiClient.get('/classrooms');
    return response.data;
};

export const createClassroom = async (classroom: Classroom): Promise<Classroom> => {
    const response = await apiClient.post('/classrooms', classroom);
    return response.data;
};

// El backend responde también con el resultado de llevar el aforo nuevo a las
// clases futuras: cuántas se actualizaron y cuáles se saltaron por tener ya más
// gente dentro de la que cabría.
export interface ClassroomCapacityStats {
    eventsUpdated: number;
    skipped: { eventId: string; fecha: string; horaInicio: string; occupied: number }[];
}

export const updateClassroom = async (
    classroom: Classroom
): Promise<Classroom & { capacityStats?: ClassroomCapacityStats }> => {
    const response = await apiClient.put(`/classrooms/${classroom._id}`, classroom);
    return response.data;
};

// B1 — uso de una sala. Se cuenta por NOMBRE, que es lo único que guardan los
// eventos y la plantilla semanal.
export const fetchClassroomUsage = async (classroomId: string): Promise<EntityUsage> => {
    const response = await apiClient.get(`/classrooms/${classroomId}/usage`);
    return response.data;
};

// B1 — mueve las clases futuras y las plantillas de esta sala a otra. No cambia
// el aforo de las clases ya creadas.
export const reassignClassroom = async (
    classroomId: string,
    targetId: string
): Promise<ReassignResponse> => {
    const response = await apiClient.post(`/classrooms/${classroomId}/reassign`, { targetId });
    return response.data;
};

// B1: devuelve `archived` — ver la nota en instructorService.
export const deleteClassroom = async (classroomId: string): Promise<DeleteResponse> => {
    const response = await apiClient.delete(`/classrooms/${classroomId}`);
    return response.data;
};
